import { UseQueryResult, useQuery } from "react-query";
import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface IPackagingRule {
    id: string;
    variantId: string;
    maxUnits: number;
    material: number;
    units: number;
    createdAt: Date;
}

export const useGetPackagingRules = (
    queryKeys: string | string[],
    variantId: string,
    productId: string,
    options?: { enabled?: boolean }
): UseQueryResult<IPackagingRule[], unknown> => {
    const auth = useAuth();

    return useQuery<IPackagingRule[], unknown>(
        [queryKeys, "packaging-rules", variantId].flat(),
        async () => {
            if (!auth.token) {
                throw new Error("Cannot fetch packaging rules without authorization token.");
            }

            return await api.Products.getPackagingRules(variantId, productId, auth.token);
        },
        {
            enabled: options?.enabled !== false && !!auth.token && !!variantId && !!productId,
        }
    );
};